import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class InstagramRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const urlSearchParams = new URLSearchParams(route.fragment);
        const community = this.authenticationService.community;
        const instagramToken = urlSearchParams.get('access_token');

        if (community) {
            if (instagramToken) {
                this.router.navigate([`/${community}/community/installation/instagram`], {
                    queryParams: { access_token: instagramToken },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/instagram`]);
            }
        }

        return true;
    }
}
